const convertCurrency = (currency) => {
    // Make currency string suitable for parseFloat() to convert by removing $
    const temp = currency.replace(/[^0-9.-]+/g, '')

    return parseFloat(temp)
}

export default convertCurrency
